/**
 * custom.js
 *
 * Custom JavaScript (jQuery) code for the Application.
 */

/**
 * Executes the JavaScript code when the DOM is ready to be used.
 * By passing the $ you can code using the $ alias for jQuery.
 * Inside of this function, $() will work as an alias for jQuery()
 * and other libraries also using $ will not be accessible under this shortcut
 */
( function($) {

	// Initialize the Foundation JavaScript
	// Documentation can be found at: http://foundation.zurb.com/docs
	$(document).foundation();

	var winWidth = $(window).width();
  let menuIsOpen = false;

	$('.menu-toggle').click(function() {
    if (!menuIsOpen) {
      $('.site-header .menu').addClass('open');
      $('.mobile-close').addClass('active');
    } else {
      $('.site-header .menu').removeClass('open');
      $('.mobile-close').removeClass('active');
    }
    menuIsOpen = !menuIsOpen;
	});

	$('.mobile-close').click(function(event) {
		$('.menu-toggle').trigger('click');
	});

	$('.main-navigation .menu-item-has-children > a').bind('touchstart', function(event){
		var parent = $(this).parents('li');
		if(!parent.hasClass('hovered')){
			event.preventDefault();
			$(this).parents('li').addClass('hovered');
		}
		else{
			$(this).parents('li').removeClass('hovered');
		}
	});


	function stickyMenu(){
		if ($(this).scrollTop() > 200){
			$('.site-header').addClass('sticky');
		}
		else{
			$('.site-header').removeClass('sticky');
		}
	}

	$(window).scroll(function() {
		winWidth = $(window).width();
		if(winWidth > 639){
			stickyMenu();
		}

		$( '.module-box:in-viewport(-400), .page-content-box:in-viewport(-400)' ).addClass('animate');
		$( '.module-box:in-viewport(400), .page-content-box:in-viewport(400)' ).addClass('animate');
		$('.loader-bar .loader:in-viewport(-10)').removeClass('zeroWidth');
		$('.loader-bar .loader:in-viewport(10)').removeClass('zeroWidth');

	});

	$('.module-banner .read-more').click(function(event) {
		event.preventDefault();
		var div = $(this).data('id'),
		scrollTo = $(div).offset().top - 60;
		$('html, body').animate({
			scrollTop: scrollTo
		}, 300);
	});

	var largeSlider = false,
		smallSlider = false;
	function makeBannerSlider(sliderType){

		if(sliderType == 'large' && !largeSlider){

			$('.banner-slider.slider-large div').each(function(index, el) {
				var bg = $(this).data('slide');
				$(this).css('background-image', 'url('+bg+')');
			});

			$('.banner-slider.slider-large').addClass('active');
			$('.banner-slider.slider-small').removeClass('active');

			​largeSlider = setInterval(function(){
				$('.banner-slider.slider-large').each(function(){
					var $cur = $(this).find('.current').removeClass('current');
					var $next = $cur.next().length?$cur.next():$(this).children().eq(0);
					$next.addClass('current');
				});
			},5000);​

			bannerSliderHeight();
		}
		else if(sliderType == 'small' && !smallSlider){
			$('.banner-slider.slider-small div').each(function(index, el) {
				var bg = $(this).data('slide');
				$(this).css('background-image', 'url('+bg+')');
			});

			$('.banner-slider.slider-large').removeClass('active');
			$('.banner-slider.slider-small').addClass('active');

			​smallSlider = setInterval(function(){
				$('.banner-slider.slider-small').each(function(){
					var $cur = $(this).find('.current').removeClass('current');
					var $next = $cur.next().length?$cur.next():$(this).children().eq(0);
					$next.addClass('current');
				});
			},5000);​

			bannerSliderHeight();
		}

	}

	function destroyBannerSlider(sliderType){
		if(sliderType == 'large'){
			clearInterval(largeSlider);
			largeSlider = false;
		}
		else if(sliderType == 'small'){
			clearInterval(smallSlider);
			smallSlider = false;
		}
	}


	function bannerSliderHeight(){
		setTimeout(function(){
			var slider = $('.banner-slider.active'),
				height = slider.outerHeight();
				slider.parents('section').css('height', height);
				$('.svg-formation').addClass('animate');
		}, 1000);
	}

	function makeBanner(){

		$('.banner-wrapper.single-page .banner-image').each(function(index, el) {

			if(winWidth > 1024){
				var image = $(this).data('large');
			}
			else if( winWidth < 1023 || winWidth > 639){
				var image = $(this).data('medium');
			}
			else{
				var image = $(this).data('small');
			}
			$(this).html('<img src="'+image+'" alt="">');
		});

	}
	makeBanner();

	function videoHeight(){
		$('.module-text_video .flex-video').each(function(index, el) {
			var height = $(this).outerHeight(),
				sectionParent = $(this).parents('section');
				sectionParent.css('min-height', height);
		});
	}
	function sliderHeight(){
		$('.module-text_slider .slider').each(function(index, el) {
			var height = $(this).outerHeight(),
				sectionParent = $(this).parents('section');
				sectionParent.css('min-height', height);
		});
	}

	$(window).on('resize', function(event) {
		winWidth = $(window).width();

		bannerSliderHeight();
		videoHeight();
		sliderHeight();
		makeBanner();

		if(winWidth > 639){

			if(smallSlider){
				destroyBannerSlider('small');
			}
			makeBannerSlider('large');
		}
		else{
			if(largeSlider){
				destroyBannerSlider('large');
			}
			makeBannerSlider('small');
		}
	});



	$(document).ready(function(){

		stickyMenu();

		$('.loader-bar .loader').each(function(index, el) {
			var loaded = $(this).data('loaded');
			$(this).css('width', loaded);
		});

		$('.module-text_video .flex-video').each(function(index, el) {
			var embed = jQuery.parseJSON( $(this).data('video') );
			$(this).html(embed);

			var container = $(this).parents('.multimedia-box');

			setTimeout(function(){
				videoHeight();
				container.css('opacity', '0.3');
			}, 1000);
		});

		$('.slider-module').on('lazyLoaded', function(event){
			var container = $(this).parents('.multimedia-box');
			setTimeout(function(){
				sliderHeight()
				container.css('opacity', '0.3');
			}, 1000);
		}).slick({
			lazyLoad: 'ondemand',
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-caret-left" aria-hidden="true"></i>Forrige</button>',
			nextArrow: '<button type="button" class="slick-next"><i class="fa fa-caret-right" aria-hidden="true"></i>Neste</button>',
			dots: true,
			dotsClass: 'slide-count',
			customPaging: function (slider, i) {
				return  (i + 1) + '/' + slider.slideCount;
			}
		});

		$('.slider-company').slick({
			lazyLoad: 'ondemand',
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
			prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-caret-left" aria-hidden="true"></i>Forrige</button>',
			nextArrow: '<button type="button" class="slick-next"><i class="fa fa-caret-right" aria-hidden="true"></i>Neste</button>',
			dots: true,
			dotsClass: 'slide-count',
			customPaging: function (slider, i) {
				return  (i + 1) + '/' + slider.slideCount;
			}
		});

		if(winWidth > 639){
			makeBannerSlider('large');
		}
		else{
			makeBannerSlider('small');
		}


		if( !$('body').hasClass('home') ){
			$('.svg-formation').addClass('animate');
		}

	});




} )(jQuery);
